import PropTypes from "prop-types";
import React from "react";

import {
	StyleSheet,
	View,
} from "react-native";
import FileAdd from "../FileAdd";
import CameraPicker from "../CameraPicker";
import VideoPicker from "../VideoPicker";
import AudioRecorder from "../AudioRecorder";
import global from "global";

import { useResources } from "@aetonix/hooks";

const styles = StyleSheet.create({
	fileInput: {
		flexDirection: "column",
	}
});

export default function FilePicker(props){
	const { localize, localizeFrom } = useResources();
	const schema = props.schema;
	const value_localization = schema.value_localization;
	let description = props.title ?  props.title : localize(schema.description);
	let title = localize("form.title");
	let title2 = localize("form.video_title");
	let title3 = localize("form.audio_title");
	const onChange = props.onChange;
	const videoEnabled = props.videoEnabled || schema.videoEnabled;
	const pdfEnabled = props.pdfEnabled || schema.pdfEnabled;
	const localDisabled = props.localDisabled || schema.localDisabled;
	const audioPlayerEnabled = props.audioPlayerEnabled || schema.audioPlayerEnabled;
	const audioRecordEnabled  = props.audioRecordEnabled  || schema.audioRecordEnabled;

	if(value_localization){
		title2 = localizeFrom(value_localization, "video") || title2;
		title3 = localizeFrom(value_localization, "audio") || title3;
		description = localizeFrom(value_localization, "pickFile") || description;
		title = localizeFrom(value_localization, "camera") || title;
	}

	const video = videoEnabled ? (
		<VideoPicker title={title2} onAdd={onChange} />
	) : null;

	const local = !localDisabled ? (
		<FileAdd id={props.id} title={description} onAdd={onChange} videoEnabled={videoEnabled} pdfEnabled={pdfEnabled} audioPlayerEnabled={audioPlayerEnabled || audioRecordEnabled}/>
	) : null;

	const fileSelectCamera = global.cordova && global.Camera ? (
		<View style={styles.mediaSelectContainer}>
			<CameraPicker title={title} onAdd={onChange} />
			{video}
		</View>
	) : null ;

	const audioRecorder = audioRecordEnabled ? (
		<AudioRecorder title={title3} onAdd={onChange} noPlayback/>
	) : null;

	return (
		<View style={styles.fileInput} >
			{fileSelectCamera}
			{audioRecorder}
			{local}
		</View>
	);
}
